import React from 'react';
import { ReactComponent as HelpIcon } from '@lifesize/ux-assets/vectors/svgIcons/help.svg';
import { colors } from '@lifesize/ux-assets';
import { makeStyles, Theme } from '@material-ui/core';

interface Props {
  desktopOpenHelp: Function;
  helpPageUrl: string;
  isDesktop: boolean;
}

const Help = (props: Props) => {
  const classes = useStyles({});

  const launchHelpPage = () => {
    if (props.isDesktop) {
      props.desktopOpenHelp(props.helpPageUrl);
    } else {
      window.open(props.helpPageUrl, '_blank');
    }
  };

  return (
    <button className={classes.helpButton} data-testid="help" onClick={launchHelpPage}>
      <HelpIcon data-testid="help-icon" />
    </button>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  helpButton: {
    background: `radial-gradient(${colors.smoke} 0%, ${colors.smoke} 55%, transparent 55%)`,
    border: 0,
    borderRadius: '50%',
    color: colors.missionFog,
    flex: '0 0 auto',
    height: 26,
    marginRight: 6,
    outline: 0,
    padding: 0,
    width: 26,

    '& svg': {
      height: '100%',
      width: 'auto'
    }
  }
}));

export default Help;
